import React from 'react';
import web3 from 'web3';

import iPlaceholder from 'assets/icon/token/default.svg';

export function getSwapDexIcon(logo_url: string) {
  if (!logo_url) {
    return wrapUrlInImg('');
  }
  return <img src={logo_url} alt="" style={{ filter: 'grayscale(100%)', width: 20 }} />;
}

export function getIconByAddr(id: string) {
  if (id === 'eth') {
    id = '0x0000000000000000000000000000000000000000';
  }
  return wrapUrlInImg(
    `https://static.debank.com/assets/${web3.utils.toChecksumAddress(id)}/logo.png`,
  );
}

export function wrapUrlInImg(
  url: string,
  alt?: string,
  size?: number,
  style?: React.CSSProperties,
) {
  return (
    <img
      src={url}
      style={{ ...style, width: size || 20, height: size || 20 }}
      alt={alt || ''}
      onError={ev => {
        // @ts-ignore
        ev.target.src = iPlaceholder;
      }}
    />
  );
}
